/* Dakol v1: zdarzenia własne (slownik pkt 8), formularze (walidacja od przyczyny, sessionStorage, generate_lead),
   404 do raportu 301. Animacje wejścia sekcji: assets/motion.css i motion.js.
   Ładowany przez base.js (data-component="events" data-load="now"). Zero bibliotek. */

const d = document;
const emit = (name, data) => (window.dakolEvent ? window.dakolEvent(name, data) : null);
const pageType = () => (d.body.className.match(/template-([a-z0-9-]+)/) || [])[1] || 'unknown';

/* 1. Telefon: każdy link tel: w motywie, przez delegację (raz na dokument). */
if (!d.documentElement.dataset.dakolEvents) {
  d.documentElement.dataset.dakolEvents = '1';
  d.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="tel:"]');
    if (!a) return;
    const product = a.closest('[data-product-id]');
    emit('dakol_phone_click', { page_type: pageType(), product_id: product ? Number(product.dataset.productId) || null : null });
  });

  /* 2. Strona 404: adres do raportu przekierowań 301. */
  if (d.querySelector('[data-404]')) {
    emit('dakol_404_viewed', { page_path: location.pathname + location.search, referrer: d.referrer || null });
  }

  /* 3. Animacje wejścia [data-reveal] obsługują assets/motion.css i motion.js (wspólne API ruchu, od 2026-10-16). */
}

/* 4. Formularze: [data-remember] pamięta pola w sessionStorage, walidacja od przyczyny (komunikaty z data-error-*),
   [data-one-of] wymaga jednego z pól, strefy projektu, generate_lead po wysłaniu. */
const messages = (form) => {
  const m = {};
  form.querySelectorAll('template[data-msg]').forEach((t) => { m[t.dataset.msg] = t.innerHTML; });
  return m;
};
function fieldError(input, text) {
  const field = input.closest('.field') || input.closest('label') || input.parentElement;
  let err = field.querySelector('.field__error');
  if (!err) {
    err = d.createElement('span');
    err.className = 'field__error';
    err.setAttribute('role', 'alert');
    field.appendChild(err);
  }
  if (!err.id) err.id = `${input.id || input.name.replace(/\W+/g, '-')}-error`;
  if (text) {
    err.textContent = text;
    err.hidden = false;
    field.classList.add('field--error');
    input.setAttribute('aria-invalid', 'true');
    const ids = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    if (!ids.includes(err.id)) input.setAttribute('aria-describedby', [...ids, err.id].join(' '));
  } else {
    err.textContent = '';
    err.hidden = true;
    field.classList.remove('field--error');
    input.removeAttribute('aria-invalid');
  }
}
const T = (key) => {
  const tpl = d.querySelector(`template[data-t="${key}"]`);
  return tpl ? tpl.content.textContent : null;
};
/* Teksty błędów: klucze z locales forms.* są renderowane przez Liquid jako data-error-* na polu albo w template[data-t]. Zapas po polsku bez numerów. */
const FALLBACK = {
  'forms.email_required': 'Podaj adres e-mail.',
  'forms.email_invalid': 'Podaj adres e-mail w formacie nazwa@domena.pl.',
  'forms.phone_required': 'Podaj numer telefonu.',
  'forms.phone_invalid': 'Podaj numer telefonu, 9 cyfr.',
  'forms.name_required': 'Podaj imię i nazwisko.',
  'forms.postal_code_invalid': 'Podaj kod pocztowy w formacie 08-110.',
  'forms.nip_invalid': 'Podaj NIP, 10 cyfr, bez myślników.',
  'forms.order_number_required': 'Podaj numer zamówienia, np. #1234.',
  'forms.message_required': 'Napisz, w czym możemy pomóc.',
  'forms.number_positive': 'Wpisz liczbę większą od zera, np. 120.',
  'forms.number_invalid': 'Wpisz liczbę, np. 8,5.',
  'forms.bucket_test_required': 'Wpisz, w ile sekund napełnia się wiadro 10 litrów.',
  'forms.consent_required': 'Zaznacz zgodę, żeby wysłać formularz.',
  'forms.choice_required': 'Wybierz jedną z opcji.',
  'forms.topic_required': 'Wybierz, czego dotyczy wiadomość.',
  required: 'Wypełnij to pole.',
};
const msg = (key) => T(key) || FALLBACK[key] || FALLBACK.required;

function validateInput(input) {
  if (input.disabled || input.type === 'hidden') return true;
  const v = (input.value || '').trim();
  const data = input.dataset;
  if (input.type === 'checkbox' && input.required && !input.checked) {
    fieldError(input, msg(data.errorRequired || 'forms.consent_required'));
    return false;
  }
  if (input.type === 'radio') {
    if (!input.required) return true;
    const group = input.form.querySelectorAll(`input[name="${input.name}"]`);
    const ok = [...group].some((r) => r.checked);
    const wrap = input.closest('.field');
    let err = wrap && wrap.querySelector('.field__error');
    if (!ok) {
      if (wrap && !err) { err = d.createElement('span'); err.className = 'field__error'; err.id = `${input.name.replace(/\W+/g, '-')}-error`; err.setAttribute('role', 'alert'); wrap.appendChild(err); }
      if (err) { err.textContent = msg(data.errorRequired || 'forms.choice_required'); err.hidden = false; group.forEach((r) => { r.setAttribute('aria-invalid', 'true'); r.setAttribute('aria-describedby', err.id); }); }
    } else if (err) { err.hidden = true; group.forEach((r) => { r.removeAttribute('aria-invalid'); r.removeAttribute('aria-describedby'); }); }
    return ok;
  }
  if (input.required && !v) {
    const key = data.errorRequired || (input.type === 'email' ? 'forms.email_required' : input.type === 'tel' ? 'forms.phone_required' : 'required');
    fieldError(input, msg(key));
    return false;
  }
  if (v && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { fieldError(input, msg('forms.email_invalid')); return false; }
  if (v && input.type === 'tel' && v.replace(/\D/g, '').length < 9) { fieldError(input, msg(data.errorPattern || 'forms.phone_invalid')); return false; }
  if (v && input.type === 'number') {
    const n = Number(v.replace(',', '.'));
    const min = input.min !== '' ? Number(input.min) : -Infinity;
    if (Number.isNaN(n)) { fieldError(input, msg('forms.number_invalid')); return false; }
    if (n < min || (min >= 0 && n <= 0 && input.required)) { fieldError(input, msg(data.errorRange || 'forms.number_positive')); return false; }
  }
  if (v && input.pattern && !new RegExp(`^(?:${input.pattern})$`).test(v)) { fieldError(input, msg(data.errorPattern || 'required')); return false; }
  fieldError(input, '');
  return true;
}

/* Streszczenie rozmowy z asystentem (?asystent=1): wstawiane do pola z data-chat-summary, tylko gdy pole jest puste;
   do 300 znaków, bez adresów e-mail i numerów telefonu (plan 4 sekcja 4.4). Treść ze sessionStorage zapisuje assistant.js. */
function fillChatSummary(form) {
  if (new URLSearchParams(location.search).get('asystent') !== '1') return;
  const field = form.querySelector('[data-chat-summary]');
  if (!field || field.value.trim()) return;
  let sum = '';
  try { sum = sessionStorage.getItem('dakol_chat_streszczenie') || ''; } catch (err) { /* brak storage */ }
  sum = sum.replace(/\S+@\S+/g, '').replace(/\+?\d[\d\s-]{7,}\d/g, '').replace(/\s+/g, ' ').trim().slice(0, 300);
  if (!sum) return;
  field.value = `${field.dataset.chatSummary} ${sum}`.trim();
  field.dispatchEvent(new Event('input', { bubbles: true }));
}

function setupForm(form) {
  if (form.dataset.eventsReady) return;
  form.dataset.eventsReady = '1';
  const key = `dakol-form-${form.dataset.remember}`;
  /* Bez danych osobowych w sessionStorage (plan część 3, pkt 12): pomijamy e-mail, telefon, imię, NIP, rachunek. */
  const osobowe = (f) => ['email', 'tel'].includes(f.type) || ['name', 'email', 'tel'].includes(f.autocomplete) || /nip|rachun|imi|nazwisk|email|telefon/i.test(f.name || '');
  const fields = () => [...form.querySelectorAll('input:not([type=hidden]):not([type=password]), textarea, select')].filter((f) => !osobowe(f) && !f.closest('[data-honeypot]'));

  /* sessionStorage: odtworzenie i zapis */
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && !form.querySelector('.notice--success')) {
      fields().forEach((f) => {
        const k = f.name;
        if (!(k in saved)) return;
        if (f.tagName !== 'SELECT' && f.type !== 'checkbox' && f.type !== 'radio' && f.value) return; /* wartość z serwera (fraza, treść po błędzie) wygrywa */
        if (f.type === 'checkbox') f.checked = saved[k] === true;
        else if (f.type === 'radio') f.checked = saved[k] === f.value;
        else f.value = saved[k];
      });
    }
  } catch (err) { /* brak sessionStorage */ }
  fillChatSummary(form);
  const save = () => {
    try {
      const o = {};
      fields().forEach((f) => {
        if (f.type === 'checkbox') o[f.name] = f.checked;
        else if (f.type === 'radio') { if (f.checked) o[f.name] = f.value; }
        else o[f.name] = f.value;
      });
      sessionStorage.setItem(key, JSON.stringify(o));
    } catch (err) { /* pamięć pełna lub zablokowana */ }
  };
  form.addEventListener('input', save);
  form.addEventListener('change', save);
  /* Po wysłaniu Shopify wraca na adres bez kotwicy (własne id formularza): fokus i przewinięcie na komunikat, żeby czytnik go odczytał. */
  const status = form.querySelector('[data-form-status]');
  if (status) {
    status.focus({ preventScroll: true });
    status.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  if (form.querySelector('.notice--success')) {
    try { sessionStorage.removeItem(key); sessionStorage.removeItem('dakol_chat_streszczenie'); } catch (err) { /* nic */ }
    /* Odświeżenie strony z komunikatem nie liczy się jako kolejny lead. */
    const nav = performance.getEntriesByType('navigation')[0];
    const reload = nav && nav.type === 'reload';
    if (form.dataset.lead && !reload) emit('generate_lead', { lead_type: form.dataset.lead, value: 0, currency: window.Shopify?.currency?.active || 'PLN' });
  }

  /* walidacja przy opuszczeniu pola i przy wysyłce */
  form.addEventListener('blur', (e) => { if (e.target.matches('input, textarea, select')) validateInput(e.target); }, true);
  form.addEventListener('submit', (e) => {
    let ok = true;
    let first = null;
    /* pole pułapka (snippet form-honeypot): wypełnione tylko przez bota, wysyłka cicho wstrzymana */
    const trap = form.querySelector('[data-honeypot] input');
    if (trap && trap.value.trim()) { e.preventDefault(); return; }
    /* druga wysyłka w trakcie pierwszej (podwójny klik, Enter) nic nie robi */
    if (form.querySelector('button[type=submit][aria-busy=true]')) { e.preventDefault(); return; }
    fields().forEach((f) => { if (!validateInput(f)) { if (ok) first = f; ok = false; } });
    /* jedno z pól (telefon albo e-mail) */
    if (form.dataset.oneOf) {
      const ids = form.dataset.oneOf.split(',');
      const any = ids.some((id) => { const el = form.querySelector(`#${id.trim()}`); return el && el.value.trim(); });
      const err = form.querySelector('[data-one-of-error]');
      if (err) err.hidden = any;
      if (!any) { ok = false; first = first || form.querySelector(`#${ids[0].trim()}`); }
    }
    /* strefy projektu: co najmniej jedna zaznaczona z powierzchnią */
    const zones = form.querySelector('[data-zones]');
    if (zones) {
      const checks = [...zones.querySelectorAll('[data-zone-check]')];
      const any = checks.some((c) => {
        const area = zones.querySelector(`[data-zone-area="${c.dataset.zoneCheck}"]`);
        return c.checked && area && Number(area.value) > 0;
      });
      const err = form.querySelector('#projekt-strefy-error');
      if (err) err.hidden = any;
      if (!any) { ok = false; first = first || checks[0]; }
    }
    if (!ok) {
      e.preventDefault();
      if (first) first.focus({ preventScroll: false });
    } else {
      form.querySelectorAll('button[type=submit]').forEach((b) => { b.setAttribute('aria-busy', 'true'); });
      /* brak sieci: po 10 s przycisk znów działa */
      setTimeout(() => form.querySelectorAll('button[type=submit]').forEach((b) => b.removeAttribute('aria-busy')), 10000);
    }
  });
  /* powrót strzałką wstecz (bfcache) nie zostawia przycisku zablokowanego */
  addEventListener('pageshow', (e) => { if (e.persisted) form.querySelectorAll('button[type=submit]').forEach((b) => b.removeAttribute('aria-busy')); });
  /* strefa: zaznaczenie przy wpisaniu powierzchni */
  form.addEventListener('input', (e) => {
    const area = e.target.closest('[data-zone-area]');
    if (!area) return;
    const check = form.querySelector(`[data-zone-check="${area.dataset.zoneArea}"]`);
    if (check && area.value) check.checked = true;
  });
}
const initForms = (scope) => scope.querySelectorAll('form[data-remember]').forEach(setupForm);
initForms(d);
d.addEventListener('shopify:section:load', (e) => initForms(e.target));

/* 5. Zapas dla zdarzeń: bufor w sessionStorage, gdy Shopify.analytics nie jest gotowe; wysyłka przy następnym wczytaniu. */
(function buffer() {
  const key = 'dakol-events-buffer';
  const ready = () => window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function';
  try {
    const pending = JSON.parse(sessionStorage.getItem(key) || '[]');
    if (pending.length && ready()) {
      pending.forEach((ev) => { try { window.Shopify.analytics.publish(ev.name, ev.data); } catch (err) { /* nic */ } });
      sessionStorage.removeItem(key);
    }
  } catch (err) { /* nic */ }
  d.addEventListener('dakol:event', (e) => {
    if (ready()) return;
    try {
      const pending = JSON.parse(sessionStorage.getItem(key) || '[]');
      pending.push({ name: e.detail.name, data: e.detail.data });
      sessionStorage.setItem(key, JSON.stringify(pending.slice(-20)));
    } catch (err) { /* nic */ }
  });
}());

export { validateInput, setupForm };
